import { render, staticRenderFns } from "./BbeeProductosServiciosBG.vue?vue&type=template&id=91433782"
import script from "./BbeeProductosServiciosBG.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosBG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports